import type { Facing } from '../core';

export type AttackVisualFrame = 'anticipationA' | 'anticipationB' | 'contact' | 'recoveryA' | 'recoveryB';
export const facingToFlipX = (facing: Facing): boolean => facing === 'LEFT';
export const resolveAttackVisualFrame = (logicalFrame: number, animationId = 'dummy-attack'): AttackVisualFrame => {
  if (animationId !== 'dummy-attack') throw new Error(`Unknown animation id: ${animationId}`);
  if (!Number.isInteger(logicalFrame) || logicalFrame < 0 || logicalFrame > 16) throw new RangeError(`Logical frame must be an integer from 0 through 16: ${logicalFrame}`);
  if (logicalFrame <= 1) return 'anticipationA';
  if (logicalFrame <= 4) return 'anticipationB';
  if (logicalFrame <= 7) return 'contact';
  if (logicalFrame <= 11) return 'recoveryA';
  return 'recoveryB';
};
export const independentTextTransform = (): Readonly<{ flipX: false }> => ({ flipX: false });
